<template>
  <ContainerBasic classes="max-w-screen-lg mx-auto">
    <div
      v-if="blockData.files.length"
      :class="props.classes"
      class="relative rounded-alt-lg bg-background-base-opc50 min-h-[200px] px-md py-lg touch:md:px-3xl touch:md:py-xl lg:px-3xl lg:py-xl min-w-[200px] grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-sm md:gap-md"
    >
      <div
        v-for="(file, index) in blockData.files"
        :key="index"
        class="max-w-full col-span-1 justify-self-start"
      >
        <div class="flex flex-row flex-wrap self-center max-w-full">
          <div class="flex flex-row self-center max-w-full flex-nowrap">
            <FaIcon
              :icon-class="file.iconClass"
              :classes="'text-primary-base mr-xs shrink-0 !min-h-[20px] !h-[20px] !min-w-[20px] !w-[20px] flex-1 self-center'"
            />
            <a
              :href="file.url"
              target="_blank"
              class="self-center mr-0 truncate whitespace-nowrap text-primary-base sm:mr-sm"
            >
              {{ file.title }}
            </a>
          </div>
          <div class="flex flex-row self-center w-full">
            <div
              class="flex shrink-0 mr-xs !min-h-[20px] !h-[20px] !min-w-[20px] !w-[20px] self-center"
            ></div>
            <p class="self-center text-sm md:text-sm text-border-dark">
              ({{ file.fileSize }})
            </p>
          </div>
        </div>
      </div>
      <div class="absolute top-0 left-xl h-md w-md bg-border-dark">
        <FaIcon
          :icon-class="'fas fa-down-to-line'"
          :classes="'text-white !h-[25px] !w-[25px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'"
        />
      </div>
      <div
        class="hidden mx-auto h-md w-md h-sm w-sm h-[20px] w-[20px] -translate-x-1/2 -translate-y-1/2"
      ></div>
    </div>
  </ContainerBasic>
</template>

<script setup lang="ts">
import ContainerBasic from '@/components/components/container-basic.vue';
import type { FileDownloadsData } from './blockType';
import FaIcon from '@/components/fa-icon.vue';

// Section type has to be a union here - pretty sure Download-List is deprecated anyway.
const props = defineProps({
  blockData: {
    type: Object as PropType<FileDownloadsData>,
    required: true,
    default: {} as FileDownloadsData,
  },
  classes: {
    type: String,
    required: false,
    default: '',
  },
});
</script>
